/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import Slider from './Slider';
import { dateList } from '../../../common/data/dateList';
import { useLocation } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function SliderDate(props: { attribute: any; select: any; setSelect: any }): JSX.Element {
    const { attribute, select, setSelect } = props;
    const query = useQuery();
    const day = query.get('day');
    const listDate = dateList();

    useEffect(() => {
        if (day) {
            if (listDate && listDate.length > 0 && day) {
                const filterDay = listDate.find((i) => i.id.toString() === day);
                setSelect(filterDay);
            }
        }
    }, [day]);

    const responsive = { 0: { items: 1 }, 1024: { items: 8 } };
    const propSlider = {
        hAutoMovil: '',
        hAuto: 'h-20',
        wAutoMovil: '',
        wAuto: '',
        hMovil: 'h-20',
        wMovil: 'w-24',
        h: 'lg:h-20 md:h-20',
        hButton: 'h-20',
        w: 'lg:w-28 md:w-28',
        widthImage: 215,
        heightImage: 120,
        activeButton: false,
        urlbutton: null,
        others: 'bg-white p-0 m-0 mb-1 md:mb-4 rounded-xl border-sm-gray-1 shadow-lg',
        content: 'text-center  mb:space-y-3 lg:space-y-3',
        card: 'cursor-pointer rounded-xl border border-sm-gray-1 h-20',
        cardText: '',
        activeHoverCard: true,
    };
    return (
        <Slider
            attribute={{ ...attribute, separator: 1, responsive: responsive }}
            detailsAll={listDate}
            propSlider={propSlider}
            select={select}
            setSelect={setSelect}
            padding={{ left: 0, right: 0 }}
            origin={'date'}
        />
    );
}
